import { useEffect } from 'react'

type PagedQuery = {
  hasNextPage: boolean
  isFetchingNextPage: boolean
  fetchNextPage: () => unknown
}

/**
 * Keeps fetching a paginated list query's next page until there are none
 * left. For lists that are only correct when complete, not lists a user
 * scrolls through.
 */
export default function useFetchAllPages({
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
}: PagedQuery) {
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) fetchNextPage()
  }, [hasNextPage, isFetchingNextPage, fetchNextPage])
}
